<template>
  <v-card>
    <slot></slot>

    <v-card-title primary-title>
      <div>
        <h3 class="headline">
          {{model.name}}
          <v-chip color="indigo" text-color="white">
            <v-avatar>
              <v-icon>account_circle</v-icon>
            </v-avatar>
            {{ model.teachers }}
          </v-chip>
        </h3>
        <p>
          <v-icon>date_range</v-icon>
          {{new Date(model.date).toLocaleString()}}
        </p>
        <p>
          <v-icon>location_on</v-icon>
          {{model.place}}
        </p>
        <p>
          <v-icon>class</v-icon>
          {{model.min_class}} bis {{model.max_class}}
        </p>
        <p>
          <v-icon>person</v-icon>
          max. {{model.max_member}} Schüler
        </p>
        <p>
          <v-icon>euro_symbol</v-icon>
          Umkosten {{model.cost}}
        </p>
      </div>
    </v-card-title>

    <v-card-text><Markdown :model="model.description"/></v-card-text>

    <v-card-text>
      <v-select v-model="privatePosition" :items="priorities" label="Deine Priorität:" @change="onChange"></v-select></v-card-text>
  </v-card>
</template>

<script>
import Markdown from '@/components/Markdown'
export default {
  components: {Markdown},
  props: {
		model: Object,
		position: Number,
		onPositionChange: Function,
  },
  data() {
    const priorities = [...Array(10).keys()].map(it => ({value: it, text: it+1}))
    return { priorities, privatePosition: this.position };
  },
  methods: {
    onChange(newValue) {
      this.onPositionChange(this.position, newValue)
    }
  },
  watch: {
    position(newValue) {
      this.privatePosition = newValue
    }
  }
};
</script>

<style>
</style>
